/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "../Alert";
import BaseCom from "../BaseCom";
import LoadingAlert from "../LoadingAlert";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from '@fortawesome/free-solid-svg-icons'
import FormInput from "../FormInput";
import Globals from "../../shared/Globals";
import { SidebarGlobal } from "../_SidebarGlobal";
import L from "../Lang";

class ManufacturerList extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: []
        };
        this.load = this.load.bind(this);
        this.search = this.search.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to="/manufacturer/new" className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Manufacturer</L></span></Link>
        </div></>);
    }


    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        this.setState({ loading: true });
        this.loading = true;
        qreq.post('/api/manufacturer/list', this.state.query, j => {
            if (j.list) {
                this.setState({ list: j.list });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
            this.loading = false;
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
            this.loading = false;
        });
    }

    search(e) {
        if (e)
            e.preventDefault();

        if (this.loading) {
            setTimeout(() => this.search(), 100);
            return;
        }

        if (this.searchTimeout)
            clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 1000);
    }


    render() {
        const header = (<h1><L>Manufacturers</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />


        return <div className="container-fluid">
            {header}
            <form onSubmit={this.search}>
                <div className="mb-3">
                    <FormInput model={this.state.query} name="search" label="Search for a manufacturer..." labelAsPlaceholder onChange={() => { this.search(); }} />
                </div>
            </form>
            <div className="mt-2 pb-3">
                {this.state.list.map(i => <Link key={i.id} to={'/manufacturer/' + i.id} role="button" className="d-block rounded data-link drop-shadow bg-light p-3 mt-2 d-flex">
                    <h5>{i.name}</h5>
                </Link>)}
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(ManufacturerList);